export const metadataItemsConstants = {
    FETCH_ALL_REQUEST: 'METADATA_ITEMS_FETCH_ALL_REQUEST',
    FETCH_ALL_SUCCESS: 'METADATA_ITEMS_FETCH_ALL_SUCCESS',
    FETCH_ALL_FAILURE: 'METADATA_ITEMS_FETCH_ALL_FAILURE'
};
